// File: utils.ts

export const getRandomAuthor = () => {
    const authors = [
        'Anonymous Helix',
        'Anonymous Mouse',
        'Anonymous Squirrel',
        'Anonymous Fox',
        'Anonymous Eagle',
        'Anonymous Wolf',
        'Anonymous Tiger'
    ];
    return authors[Math.floor(Math.random() * authors.length)];
};

export const formatDate = (date: Date) => {
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    };
    const today = new Date();
    const isToday = date.toDateString() === today.toDateString();
    return isToday
        ? date.toLocaleString(undefined, options)
        : date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
};

export const ReadableDate = (timestamp: string) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = date.toLocaleString("en-US", { month: "long" });
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const amPm = hours >= 12 ? "PM" : "AM";
    const formattedHour = hours % 12 || 12;
    return `${month} ${day}, ${year}, ${formattedHour}:${minutes} ${amPm}`;
};

export const getUniqueTags = (comments: { tags: string[] }[]): string[] => {
    const allTags = comments.flatMap(comment => comment.tags);
    return Array.from(new Set(allTags));
};

export const getUniqueTitles = (comments: { title: string }[]): string[] => {
    const allTitles = comments.map(comment => comment.title);
    return Array.from(new Set(allTitles));
};
